/* --sfsx-vw: the viewport width WITHOUT the scrollbar (100vw includes it). Used by full-bleed breakouts in
   sfsx-theme.css (e.g. the Warehouse Items masthead) so they never overshoot the page on desktop. */
(function () {
  var d = document.documentElement;
  function set() { d.style.setProperty('--sfsx-vw', d.clientWidth + 'px'); }
  set();
  window.addEventListener('resize', set, { passive: true });
})();

/* SFSX motion — shared scroll-reveal for [data-sfsx-reveal] / .sfsx-reveal + count-up for [data-sfsx-count].
   Identical engine to the inline one in sections/sfsx-hero.liquid (home page); guarded by window.__sfsxMotion
   so whichever copy runs first wins and the other is a no-op. */
(function () {
  if (window.__sfsxMotion) return;
  window.__sfsxMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) || reduce) return;
  root.classList.add('sfsx-js');

  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });

  function countUp(el) {
    if (el.__sfsxCounted) return;
    el.__sfsxCounted = true;
    var text = el.textContent.trim();
    var m = text.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!target || target < 10) return;
    var prefix = m[1], suffix = m[3], useComma = m[2].indexOf(',') > -1;
    var dur = 1400, start = null;
    function fmt(n) { n = Math.round(n); return useComma ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : String(n); }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step); else el.textContent = text;
    }
    requestAnimationFrame(step);
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { countUp(e.target); countIO.unobserve(e.target); }
    });
  }, { threshold: 0.4 });

  function scan(scope) {
    (scope || document).querySelectorAll('[data-sfsx-reveal], .sfsx-reveal').forEach(function (el) {
      if (!el.classList.contains('is-in')) revealIO.observe(el);
    });
    (scope || document).querySelectorAll('[data-sfsx-count]').forEach(function (el) { countIO.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  setTimeout(function () {
    document.querySelectorAll('[data-sfsx-reveal]:not(.is-in), .sfsx-reveal:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
    });
  }, 4000);
})();